module.exports = __webpack_public_path__ + "img/content2.31864a00.png";